import moment from 'moment';
import { fieldNames, dateFields } from '../../config';

const filterCallbackFn = ([_key, value]) => {
  if (typeof value === 'string') {
    return Boolean(value.trim());
  }

  if (typeof value === 'number') {
    return Boolean(value);
  }

  if (typeof value === 'boolean' || moment.isMoment(value)) {
    return true;
  }

  if (Array.isArray(value)) {
    return Boolean(value.length);
  }

  return false;
};

const reduceCallbackFn = (acc, [key, value]) => {
  const val = typeof value === 'string' ? value.trim() : value;

  switch (true) {
    case dateFields.has(key): {
      acc[key] = val.clone().set({ second: 0 }).utc().format();
      break;
    }

    case key === fieldNames.initiators: {
      acc[key] = val.map((id) => ({
        id,
        isMain: 0,
      }));
      break;
    }

    case key === fieldNames.responsible:
    case key === fieldNames.notifyTo: {
      acc[key] = val.map((id) => id);
      break;
    }

    case key === fieldNames.type:
    case key === fieldNames.reason:
    case key === fieldNames.city: {
      acc[key] = val;
      break;
    }

    case key === fieldNames.files: {
      acc[key] = val.map((file) => file.originFileObj);
      break;
    }

    default: {
      acc[key] = val;
    }
  }

  return acc;
};

export const transformValues = (formValues) =>
  Object.entries(formValues)
    .filter(filterCallbackFn)
    .reduce(reduceCallbackFn, {});
